import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OtpVerifyResponse } from '../models/otp-verify-response';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OtpVerifyService {

constructor(
  private _http: HttpClient) { }

  verify(otpCode: string, secondCode: string){
    const payload = {
      "otp": otpCode,
      "secondaryIdentifier": secondCode
    };

    return this._http.post<OtpVerifyResponse>(`${environment.apiUrl}/chat/verify`, payload);
  }
}